import { ToggleButton, ToggleButtonGroup, styled } from '@mui/material';

const ToggleContainer = styled(ToggleButtonGroup)(({ theme }) => ({
  borderRadius: '100px',
  padding: theme.spacing(theme.spacingSizes.xxs),
  backgroundColor: theme.palette.grey[100],

  '& .MuiToggleButtonGroup-firstButton': {
    borderRadius: '100px',

    '&.Mui-disabled': {
      border: 'none',
    },
  },
  '& .MuiToggleButtonGroup-lastButton': {
    borderRadius: '100px',

    '&.Mui-disabled': {
      border: 'none',
    },
  },
}));

const Option = styled(ToggleButton)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.xxs, theme.spacingSizes.sm),
  color: theme.palette.grey[500],
  fontSize: theme.fontSizes.regular,
  lineHeight: '150%',
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: '100px',
  textTransform: 'none',

  '&:hover': {
    backgroundColor: 'transparent',
  },

  '&.Mui-selected': {
    backgroundColor: theme.palette.background.paper,
    outline: `1px solid ${theme.palette.grey[300]}`,

    '&:hover': {
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

type Props<T extends string> = {
  value: T;
  options: Array<{
    value: T;
    label: string;
  }>;
  onChange?: (value: T) => void;
  disabled?: boolean;
};

const Toggle = <T extends string>({
  value,
  options,
  onChange,
  disabled,
}: Props<T>): JSX.Element => {
  return (
    <ToggleContainer
      size="small"
      value={value}
      exclusive={true}
      onChange={(_, value: T | null) => {
        if (value !== null) {
          onChange?.(value);
        }
      }}
      disabled={disabled}
    >
      {options.map((option) => (
        <Option value={option.value} key={option.value}>
          {option.label}
        </Option>
      ))}
    </ToggleContainer>
  );
};

export default Toggle;
